import { RuleType } from "react-querybuilder";
import { AnyObjectSchema } from "yup";
import ObjectSchema, { ObjectShape } from "yup/lib/object";

export function searchMeta(search: boolean | { flat: boolean }) {
    return { search };
}

export function shouldSearch(meta: { search?: boolean | { flat: boolean } }) {
    let isSearchable = meta?.search ?? true;
    return isSearchable;
}

export function shouldFlattenChildren(meta: { search?: boolean | { flat: boolean } }) {
    let isFlattened = typeof meta?.search === 'object' ? meta.search.flat : false;
    return isFlattened;
}

export function getFieldsFromSchemaFlattenArrays(schemaFields: Record<string, any>, parentLabel = '', shouldFlatten = true) {

    const resultFields = [];

    Object.keys(schemaFields).forEach(key => {
        let field = schemaFields[key];
        let isSearchable = shouldSearch(field?.spec?.meta);
        let isFlattened = shouldFlattenChildren(field?.spec?.meta) || shouldFlatten;

        if (!isSearchable) {
            return;
        }
        // let fieldLabel = [parentLabel, field?.spec.label ?? key].filter(Boolean).join(' - ');
        let fieldLabel = field?.spec.label ?? key;
        let isArray = field?.type === 'array';
        let isObject = field?.type === 'object';

        const validator = (r: RuleType) => !!r.value;

        if (isFlattened) {
            if (isArray) {
                const innerFields = getFieldsFromSchemaFlattenArrays(field?.innerType?.fields ?? {}, fieldLabel, shouldFlatten);
                innerFields.forEach(innerField => {
                    resultFields.push(innerField);
                });
            } else {
                resultFields.push({
                    name: key,
                    label: fieldLabel,
                    datatype: field?.type,
                    inputType: field?.type,
                    description: parentLabel,
                    validator: validator,
                    // matchModes: (isArray || isObject) ? ['some'] : false,
                    // subproperties: (isArray || isObject) ? getFieldsFromSchemaFlattenArrays(field?.innerType?.fields ?? field?.fields ?? {}, fieldLabel) : undefined,
                    // options: !showAsSubproperties && (isArray || isObject) ? getFieldsFromSchema(field?.innerType?.fields ?? field?.fields ?? {}) : undefined,
                });
            }
        } else {
            resultFields.push({
                name: key,
                label: field?.spec.label ?? key,
                datatype: field?.type,
                inputType: field?.type,
                matchModes: (isArray || isObject) ? ['all', 'some'] : false,
                subproperties: (isArray || isObject) ? getFieldsFromSchemaFlattenArrays(field?.innerType?.fields ?? field?.fields ?? {}, '', shouldFlatten) : undefined,
                description: parentLabel,
                validator: validator,
                // options: !showAsSubproperties && ((field?.type === 'array') || (field?.type === 'object')) ? getFieldsFromSchema(field?.innerType?.fields ?? field?.fields ?? {}) : undefined,
            });
        }
    });
    return resultFields.sort((a, b) => a.description.localeCompare(b.description) || a.label.localeCompare(b.label));
}
